import {
    LOGIN,
    LOGOUT,
    POST_LOGIN,
    POST_LOGOUT,
    postLoginSuccess,
    postLoginFailed,
} from '../../../actions/app/login/login.actions'
import {API_ERROR, API_SUCCESS, apiRequest} from '../../../actions/core/api/api.actions'
import {setError, setIsLogin, setLoader} from '../../../actions/app/ui/ui.actions'
import {setNotification} from '../../../actions/core/notifications/notifications.actions'
import {setUser} from '../../../actions/app/user/user.actions'

export const loginMiddleware = () => next => action => {
    next(action)

    const { payload } = action

    switch (action.type){
        case POST_LOGIN:
            next([
                apiRequest({body: payload.body, method: 'POST', url: payload.data, entity: LOGIN}),
                setLoader({state: true, entity: LOGIN})
            ])
            break

        case `${LOGIN} ${API_SUCCESS}`:
            // Le token est géré via cookie HttpOnly
            next([
                setIsLogin({state: true, entity: LOGIN}),
                setUser({user: payload.data.user}),
                setError({state: false, entity: LOGIN}),
                setLoader({state: false, entity: LOGIN}),
                postLoginSuccess(),
            ])
            break

        case `${LOGIN} ${API_ERROR}`:
            // Check if it's a no_password_set error
            const errorResponse = payload.data?.response?.data

            if (errorResponse?.error === 'no_password_set') {
                next([
                    setNotification({
                        entity: LOGIN,
                        title: 'Mot de passe non configuré',
                        html: errorResponse.message || 'Votre mot de passe n\'est pas configuré. Un email vous a été envoyé pour le définir.',
                        icon: 'warning'
                    }),
                    setError({state: false, entity: LOGIN}),
                    setLoader({state: false, entity: LOGIN}),
                    postLoginFailed(),
                ])
            } else {
                next([
                    setError({state: true, entity: LOGIN}),
                    setLoader({state: false, entity: LOGIN}),
                    postLoginFailed(),
                ])
            }
            break

        case POST_LOGOUT:
            next([
                apiRequest({method: 'POST', url: payload.data, entity: LOGOUT}),
                setLoader({state: true, entity: LOGOUT})
            ])
            break

        case `${LOGOUT} ${API_SUCCESS}`:
            next([
                setError({state: false, entity: LOGOUT}),
                setLoader({state: false, entity: LOGOUT})
            ])
            window.location.href = '/login'
            break;

        case `${LOGOUT} ${API_ERROR}`:
            next([
                setError({state: true, entity: LOGOUT}),
                setLoader({state: false, entity: LOGOUT})
            ])
            break;

        default:
            break
    }
    return null
}
